import { Action, createReducer, on } from '@ngrx/store';
import { FooterState } from '@nx-customer-apps/shared/interfaces';
import { FooterActions } from './footer.actions';

import data from '../../../../../../package.json';

export const initialFooterState: FooterState = {
    version: data.version,
    appVersion: `v${data.version}`,
    apiVersion: '',
    applicationVersion: data.version,
    calculationApiVersion: ''
};

const reducer = createReducer(
    initialFooterState,
    on(FooterActions.getApiInfoSuccess, (state, { calculationApiVersion, appVersion }) => ({
        ...state,
        apiVersion: appVersion,
        calculationApiVersion: calculationApiVersion ? `v${calculationApiVersion}` : ''
    }))
);

export function footerReducer(state: FooterState | undefined, action: Action) {
    return reducer(state, action);
}
